import { FCM_VAPID } from "Config";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC5X2o6k1hrql2ds0qO7KVVqun12csWOvE",
    authDomain: "atease-9e56c.firebaseapp.com",
    projectId: "atease-9e56c",
    storageBucket: "atease-9e56c.firebasestorage.app",
    messagingSenderId: "48942492651",
    appId: "1:48942492651:web:719c9052bb5cf8952347ae"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Request Notification Permission
export const requestPermission = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const token = await getToken(messaging, { vapidKey: FCM_VAPID });
            console.log("FCM Token:", token);
            return token; // Send token to the backend
        } else {
            console.log("Notification permission denied");
        }
    } catch (error) {
        console.error("Error getting notification permission:", error);
    }
    return null;
};

// Listen for foreground messages
export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            console.log("Message received:", payload);
            resolve(payload);
        });
    });